import { Outlet, NavLink, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { LayoutDashboard, FolderTree, BookOpen, Users, ShieldCheck, Tag, Settings, FileText, User } from 'lucide-react';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/categories', label: 'Categories', icon: FolderTree },
  { to: '/admin/test-series', label: 'Test Series', icon: BookOpen, matchPaths: ['/admin/test-series', '/admin/tests/'] },
  { to: '/admin/users', label: 'Users', icon: Users },
  { to: '/admin/coupons', label: 'Coupons', icon: Tag },
  { to: '/admin/pages', label: 'Pages', icon: FileText },
  { to: '/admin/settings', label: 'Settings', icon: Settings },
  { to: '/admin/profile', label: 'My Profile', icon: User },
];

export default function AdminLayout() {
  const { user } = useAuth();
  const location = useLocation();
  const isRootAdmin = user?.role === 'root_admin';

  const allItems = isRootAdmin
    ? [...navItems, { to: '/admin/sub-admins', label: 'Managing Multiple Admins', icon: ShieldCheck }]
    : navItems;

  const isItemActive = (item) => {
    if (item.end) return location.pathname === item.to;
    if (item.matchPaths) return item.matchPaths.some(p => location.pathname.startsWith(p));
    return location.pathname.startsWith(item.to);
  };

  return (
    <div className="flex min-h-[calc(100vh-64px)]" data-testid="admin-layout">
      {/* Sidebar */}
      <aside className="admin-sidebar border-r border-zinc-200 bg-white flex flex-col" data-testid="admin-sidebar">
        <div className="p-4 border-b border-zinc-200">
          <h2 className="font-['Outfit'] font-semibold text-[#0A0A0A]">Admin Panel</h2>
          <p className="text-xs text-[#52525B] mt-0.5">{user?.email}</p>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {allItems.map(item => {
            const active = isItemActive(item);
            return (
              <NavLink key={item.to} to={item.to} end={item.end}
                className={`flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm font-medium transition-colors ${
                  active ? 'bg-[#F4F0FF] text-[#7551e8]' : 'text-[#52525B] hover:bg-zinc-50'
                }`}
                data-testid={`admin-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
              >
                <item.icon size={18} />
                {item.label}
              </NavLink>
            );
          })}
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 overflow-y-auto bg-[#F9FAFB] p-6" data-testid="admin-content">
        <Outlet />
      </main>
    </div>
  );
}
